import queryString from 'query-string';
import { CLEAR_SIMULATED_USER, SET_LANG, SET_LOADING_SIMULATED_USER, SET_SIMULATED_AGENT, SET_SIMULATED_DATA, SET_SIMULATED_USER, SET_TEST } from '../actions/config.actions';
import axios from "../utils/axiosConfig";
import { getCookie, setCookie } from '../utils/cookies';
import i18n from '../utils/i18n';


let { lang } = queryString.parse(location.search);
lang = lang || getCookie('i18next') || getCookie('locale') || 'en';

const initialState = {
  simulatedUser: localStorage.getItem("simulatedUser") || null,
  simulatedData: JSON.parse(localStorage.getItem("simulatedData") || null),
  simulatedAgent: localStorage.getItem("simulatedAgent") || null,
  lang,
  test: JSON.parse(localStorage.getItem('test_flow') || '[]'),
  loadingSimulatedUser: false,
};

i18n.changeLanguage(lang);

export default function configReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LANG:
      setCookie('i18next', action.payload);
      setCookie('locale', action.payload);
      return {
        ...state,
        lang: action.payload,
      };
    case SET_LOADING_SIMULATED_USER:
      return {
        ...state,
        loadingSimulatedUser: action.payload,
      };
    case SET_SIMULATED_USER:
      if (action.payload) {
        localStorage.setItem("simulatedUser", action.payload);
        axios.defaults.headers.common['x-simulated-user'] = action.payload;
      } else {
        localStorage.removeItem("simulatedUser");
        localStorage.removeItem("simulatedData");
        axios.defaults.headers.common['x-simulated-user'] = null;
      }
      return {
        ...state,
        simulatedUser: action.payload,
        simulatedData: null,
      };
    case SET_SIMULATED_DATA:
      if (action.payload) {
        localStorage.setItem("simulatedData", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("simulatedData");
      }
      return {
        ...state,
        simulatedData: action.payload
      };
    case CLEAR_SIMULATED_USER:
      localStorage.removeItem("simulatedData");
      localStorage.removeItem("simulatedUser");
      localStorage.removeItem("simulatedData");
      axios.defaults.headers.common['x-simulated-user'] = null;
      return {
        ...state,
        simulatedData: null,
        simulatedUser: null,
      };
    case SET_SIMULATED_AGENT:
      if (action.payload) {
        localStorage.setItem("simulatedAgent", JSON.stringify(action.payload));
        axios.defaults.headers.common['x-simulated-agent'] = action.payload.id;
      } else {
        localStorage.removeItem("simulatedAgent");
        axios.defaults.headers.common['x-simulated-agent'] = null;
      }

      return {
        ...state,
        simulatedAgent: action.payload,
      };

    case SET_TEST:
      localStorage.setItem('test_flow', JSON.stringify(action.payload));
      return {
        ...state,
        test: action.payload,
      };
    default:
      return state;
  }
}
